import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { ScreenProps } from "./types";

export const Assessed = ({ state: { accountInfo } }: ScreenProps) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <SvgInline name="break" size="92" />
    <Text as="h4" textStyle="heading4">
      Your application is currently being assessed
    </Text>
    <Text>
      Your application has been received and is being assessed. You'll be
      notified of the outcome within the next 2 business days.
    </Text>
    <Link
      appearance="primary-button"
      variant="blue-button"
      width="216"
      href="/manage-account"
      newTab={false}
    >
      Manage account
    </Link>
  </Stack>
);
